import React from "react";
import { Link } from "react-router-dom";
import { MessageSquare, ChevronRight } from "lucide-react";
import { installerBranding } from "@/branding/Branding";

/**
 * CUST-EXP-001A1 · Support card — routes customers to the existing
 * in-app Messages thread. Phone/email are intentionally OMITTED
 * because there is no verified source for Pearl's real contact
 * details in this environment; we never invent or hard-code such
 * values on the customer dashboard.
 *
 * The Profile screen retains the full contact block that already
 * mirrors the mobile app's `installer.ts` — this simply keeps the
 * dashboard's copy honest.
 */
export default function SupportCard() {
    return (
        <div className="pe-card p-5 md:p-6" data-testid="support-card">
            <div className="flex items-center gap-2 mb-3">
                <span className="pe-icon-tile w-8 h-8"><MessageSquare size={14} strokeWidth={1.75} /></span>
                <div>
                    <div className="text-[11px] tracking-[0.14em] uppercase text-[#4B5565]">Need a hand?</div>
                    <div className="text-base text-[#131B2F] font-medium">Talk to {installerBranding.name}</div>
                </div>
            </div>
            <div className="space-y-2">
                <Link
                    to="/messages"
                    data-testid="support-open-messages"
                    className="flex items-center gap-3 p-3 rounded-lg border border-[#E5E7EB] hover:bg-[#F5F5F7] transition-colors"
                >
                    <MessageSquare size={16} strokeWidth={1.75} className="text-[#3E9E2E]" />
                    <div className="flex-1 min-w-0">
                        <div className="text-sm text-[#131B2F] font-medium">Message the team</div>
                        <div className="text-xs text-[#4B5565]">Your installer replies inside your project thread</div>
                    </div>
                    <ChevronRight size={14} className="text-[#4B5565]" />
                </Link>
                <p className="text-xs text-[#4B5565] pt-1" data-testid="support-note">
                    Additional contact details are available on your{" "}
                    <Link to="/profile" className="text-[#3E9E2E] hover:underline" data-testid="support-open-profile">
                        Profile
                    </Link>
                    .
                </p>
            </div>
        </div>
    );
}
